import React from "react";
import noImagen from "images/no-image.jpg";

const NoImagePlaceholder = ({
  alt = "Sin imagen",
  style = {},
  className = "",
  height = "150px",
  width = "150px",
}) => {
  return (
    <div
      className={`no-image-placeholder d-flex align-items-center justify-content-center bg-light rounded ${className}`}
      style={{ height, width, ...style }}
    >
      <img
        src={noImagen}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "inherit",
        }}
      />
    </div>
  );
};

export default NoImagePlaceholder;
